import React, { useMemo } from 'react';
import { format } from 'date-fns';
import { Alert } from '@material-ui/lab';
import { ConfigFieldControl, ConfigTextField } from '@sierralabs/core-ui';
import SiteQueryFieldPicker from '../../common/pickers/SiteQueryFieldPicker';
import { useConfigComponent } from '../../hooks/component/useConfigComponent';
import { useQueryDisplayValue } from '../../hooks/component/useQueryDisplayValue';
import { useSubscribeComponentChanges } from '../../hooks/component/useSubscribeComponentChanges';
import { useSiteContext } from '../../SiteContext';
import { SiteComponent } from '../SiteComponentPlugin';
import { useGetQueriesForComponentTree } from '../../hooks/component/useGetQueriesForComponentTree';
export const SiteDate = props => {
    const component = useSubscribeComponentChanges(SiteDatePlugin, props);
    const { format: dateFormat, queryId, queryField } = component.props || {};
    const { isHover, hoverProps } = useSiteContext();
    let value = useQueryDisplayValue(queryId, queryField, props.queryValueProps);
    const classes = ['site-date'];
    if (isHover(component)) {
        classes.push('component-hover');
    }
    const result = useMemo(() => {
        try {
            // fix date input format
            if (value &&
                typeof value === 'string' &&
                value.match(/^\d{4}-\d{2}-\d{2}$/)) {
                // fix date only fields (otherwise date offset by 1)
                value = `${value}T00:00:00`;
            }
            return value && dateFormat
                ? format(new Date(value), dateFormat)
                : undefined;
        }
        catch (error) {
            return React.createElement(Alert, { severity: 'error' }, error.toString());
        }
    }, [value, dateFormat]);
    return (React.createElement(SiteComponent, Object.assign({ plugin: SiteDatePlugin }, props),
        React.createElement("span", Object.assign({ className: classes.join(' ') }, hoverProps(component)), result)));
};
export const SiteDateConfigurator = props => {
    var _a, _b, _c;
    const { component, update } = useConfigComponent(props.component);
    const queries = useGetQueriesForComponentTree(component);
    return (React.createElement(React.Fragment, null,
        React.createElement(ConfigFieldControl, null,
            React.createElement(SiteQueryFieldPicker, { queryId: (_a = component.props) === null || _a === void 0 ? void 0 : _a.queryId, queryField: (_b = component.props) === null || _b === void 0 ? void 0 : _b.queryField, options: queries, onChange: value => {
                    update('props.queryId', value.queryId);
                    update('props.queryField', value.queryField);
                } })),
        React.createElement(ConfigFieldControl, null,
            React.createElement(ConfigTextField, { fullWidth: true, label: 'Date Format', helperText: 'Enter date format', value: ((_c = component.props) === null || _c === void 0 ? void 0 : _c.format) || '', onChange: event => update('props.format', event.target.value) }))));
};
export const SiteDatePlugin = {
    name: 'Date',
    type: 'date',
    component: SiteDate,
    configurator: SiteDateConfigurator,
    initConfig: component => {
        if (!component.props) {
            component.props = {};
        }
        if (!component.props.format) {
            component.props.format = 'MM-dd-yyyy';
        }
        return component;
    }
};
//# sourceMappingURL=SiteDatePlugin.js.map